module.exports = __webpack_public_path__ + "static/img/app_iVoice.00496e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iapp/app_iVoice.png
// module id = 556
// module chunks = 0